



















import Vue from "vue";
import { RoomDetail } from "@/models/room";
import VaCard from "@/components/molecules/VaCard.vue";
import VaTextField from "@/components/atoms/VaTextField.vue";
import RemoteProviders from "./RemoteProviders.vue";

export default Vue.extend({
  name: "RoomRemoteManagementIos",
  components: {
    VaCard,
    VaTextField,
    RemoteProviders,
  },
  computed: {
    room(): RoomDetail {
      return this.$store.getters["room/room"];
    },
  },
});
